import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { usePortfolioStore } from '../../store'
import { NAVIGATION_ITEMS } from '../../types/navigation'

interface NavigationProps {
  className?: string
  onLinkClick?: () => void
}

const Navigation: React.FC<NavigationProps> = ({
  className = '',
  onLinkClick,
}) => {
  const location = useLocation()
  const setCurrentPage = usePortfolioStore(state => state.setCurrentPage)

  const handleLinkClick = (path: string) => {
    setCurrentPage(path)
    onLinkClick?.()
  }

  return (
    <nav className={`navigation ${className}`}>
      <ul className="navigation-list">
        {NAVIGATION_ITEMS.map(item => (
          <li key={item.path} className="navigation-item">
            <Link
              to={item.path}
              className={`navigation-link ${
                location.pathname === item.path ? 'active' : ''
              }`}
              onClick={() => handleLinkClick(item.path)}
              title={item.title}
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default Navigation
